import { z } from 'zod';

/**
 * B-A.2.1 — UoM code, lenient string.
 *
 * Изначально был z.enum() со строгим UI-vocabulary (pcs/m2/kg/...). При деплое
 * v0.3.4 (2026-05-16) prod данные содержат русские/legacy UoMs ('шт', 'услуга',
 * etc.) → strict enum ломал parse Invoice detail. Validation controlled
 * vocabulary'a теперь только на form-submit level (Select с options), на parse
 * — lenient.
 *
 * Locale через `@staiter/i18n` ключами `units_{code}_short` / `units_{code}_long`
 * (для canonical codes ниже).
 *
 * Числовые конверсии — `packages/shared/src/entities/uom.ts` / `packages/config/uom-conversions.v1.json`.
 */
export const UomCode = z.string();
export type UomCode = z.infer<typeof UomCode>;

/** Canonical UI-vocabulary — используется в Select-pickers, ESM enum для switch. */
export const CANONICAL_UOM_CODES = [
  'pcs',
  'm2',
  'm3',
  'kg',
  'g',
  't',
  'L',
  'ml',
  'm',
  'cm',
  'h',
  'min',
  'pkg',
  'set',
  'roll',
] as const;
export type CanonicalUomCode = (typeof CANONICAL_UOM_CODES)[number];
